import * as React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
  type: string
  confidential?: boolean
}

const FileType = (props: Props) => (
  <div className="ggfiletype text-uppercase d-flex flex-column align-items-center justify-content-center">
    {props.confidential && (
      <FontAwesomeIcon
        className="mb-2"
        icon={['fas', 'lock']}
        style={{ fontSize: '24px' }}
      />
    )}
    {props.type.toUpperCase()}
  </div>
)

export default FileType



// WEBPACK FOOTER //
// ./src/common/FileType.component.tsx